// // // export function Contact() {
// // //   return (
// // //     <section
// // //       id="contact"
// // //       className="relative bg-gray-50 py-24 px-6 sm:px-12 overflow-hidden"
// // //     >
// // //       {/* Background Circles */}
// // //       <div className="absolute -top-40 -right-40 w-[500px] h-[500px] bg-gradient-to-tr from-blue-400 to-purple-400 rounded-full opacity-20 blur-3xl animate-pulse-slow"></div>
// // //       <div className="absolute -bottom-40 -left-40 w-[400px] h-[400px] bg-gradient-to-tr from-pink-300 to-yellow-300 rounded-full opacity-15 blur-2xl"></div>

// // //       <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-16 items-center relative z-10">
// // //         {/* Left Side: KevMark Info */}
// // //         <div className="space-y-6 flex flex-col justify-center">
// // //           <h2 className="text-4xl font-extrabold text-gray-900">
// // //             Get in Touch with{" "}
// // //             <span className="text-blue-600">KevMark Investments</span>
// // //           </h2>
// // //           <p className="text-gray-600 text-lg">
// // //             Have questions about investments, partnerships, or our services?
// // //             We’re here to help you achieve your financial goals. Fill out the
// // //             form and we’ll get back to you promptly.
// // //           </p>

// // //           <div className="space-y-3 text-gray-700">
// // //             <p className="flex items-center gap-2">
// // //               <span className="font-semibold">Email:</span> info@kevmark.com
// // //             </p>
// // //             <p className="flex items-center gap-2">
// // //               <span className="font-semibold">Phone:</span> +256 700 123 456
// // //             </p>
// // //             <p className="flex items-center gap-2">
// // //               <span className="font-semibold">Address:</span> Kampala, Uganda
// // //             </p>
// // //           </div>
// // //         </div>

// // //         {/* Right Side: Form */}
// // //         <div className="bg-white p-10 sm:p-12 rounded-3xl shadow-xl">
// // //           <h3 className="text-2xl font-bold text-gray-900 mb-6">
// // //             Send a Message
// // //           </h3>
// // //           <form className="space-y-6">
// // //             <div className="grid sm:grid-cols-2 gap-6">
// // //               <div className="relative">
// // //                 <input
// // //                   type="text"
// // //                   id="name"
// // //                   placeholder="Your Name"
// // //                   className="peer w-full border-b-2 border-gray-300 focus:border-blue-600 outline-none py-3 placeholder-transparent transition-all"
// // //                 />
// // //                 <label
// // //                   htmlFor="name"
// // //                   className="absolute left-0 top-3 text-gray-400 text-sm
// // //                     peer-placeholder-shown:top-3 peer-placeholder-shown:text-gray-400 peer-placeholder-shown:text-base
// // //                     peer-focus:top-0 peer-focus:text-blue-600 peer-focus:text-sm transition-all"
// // //                 >
// // //                   Your Name
// // //                 </label>
// // //               </div>
// // //               <div className="relative">
// // //                 <input
// // //                   type="email"
// // //                   id="email"
// // //                   placeholder="Your Email"
// // //                   className="peer w-full border-b-2 border-gray-300 focus:border-blue-600 outline-none py-3 placeholder-transparent transition-all"
// // //                 />
// // //                 <label
// // //                   htmlFor="email"
// // //                   className="absolute left-0 top-3 text-gray-400 text-sm
// // //                     peer-placeholder-shown:top-3 peer-placeholder-shown:text-gray-400 peer-placeholder-shown:text-base
// // //                     peer-focus:top-0 peer-focus:text-blue-600 peer-focus:text-sm transition-all"
// // //                 >
// // //                   Your Email
// // //                 </label>
// // //               </div>
// // //             </div>
// // //             <div className="relative">
// // //               <textarea
// // //                 id="message"
// // //                 rows="5"
// // //                 placeholder="Your Message"
// // //                 className="peer w-full border-b-2 border-gray-300 focus:border-blue-600 outline-none py-3 placeholder-transparent transition-all"
// // //               ></textarea>
// // //               <label
// // //                 htmlFor="message"
// // //                 className="absolute left-0 top-3 text-gray-400 text-sm
// // //                   peer-placeholder-shown:top-3 peer-placeholder-shown:text-gray-400 peer-placeholder-shown:text-base
// // //                   peer-focus:top-0 peer-focus:text-blue-600 peer-focus:text-sm transition-all"
// // //               >
// // //                 Your Message
// // //               </label>
// // //             </div>
// // //             <button
// // //               type="submit"
// // //               className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold hover:bg-blue-700 transition-all shadow-md"
// // //             >
// // //               Send Message
// // //             </button>
// // //             <p className="text-gray-400 text-sm mt-2 text-center">
// // //               We usually respond within{" "}
// // //               <span className="font-medium text-gray-700">24 hours</span>
// // //             </p>
// // //           </form>
// // //         </div>
// // //       </div>
// // //     </section>
// // //   );
// // // }

// // import React, { useEffect } from "react";
// // import { useLocation } from "react-router-dom";

// // export function Contact() {
// //   const { pathname } = useLocation();

// //   // Scroll to top on route change
// //   useEffect(() => {
// //     window.scrollTo(0, 0);
// //   }, [pathname]);

// //   // Set document title
// //   useEffect(() => {
// //     document.title = "Contact Us - KevMark Investments"; // Set page title
// //   }, []);

// //   return (
// //     <section
// //       id="contact"
// //       className="relative bg-gray-50 py-16 px-4 sm:px-8 overflow-hidden bg-cover bg-center"
// //       style={{
// //         minHeight: "calc(100vh - 80px)",
// //         backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')`,
// //       }}
// //     >
// //       {/* Background Circles */}
// //       <div className="absolute -top-32 -right-32 w-[400px] h-[400px] bg-gradient-to-tr from-blue-400 to-purple-400 rounded-full opacity-15 blur-3xl animate-pulse-slow"></div>
// //       <div className="absolute -bottom-32 -left-32 w-[300px] h-[300px] bg-gradient-to-tr from-pink-300 to-yellow-300 rounded-full opacity-10 blur-2xl"></div>

// //       <div className="max-w-5xl mx-auto grid lg:grid-cols-2 gap-12 items-center relative z-10">
// //         {/* Left Side: KevMark Info */}
// //         <div className="space-y-4 flex flex-col justify-center">
// //           <h2 className="text-3xl font-extrabold text-white">
// //             Get in Touch with{" "}
// //             <span className="text-blue-400">KevMark Investments</span>
// //           </h2>
// //           <p className="text-gray-200 text-base">
// //             Have questions about investments, partnerships, or our services?
// //             We’re here to help you achieve your financial goals. Fill out the
// //             form and we’ll get back to you promptly.
// //           </p>

// //           <div className="space-y-2 text-gray-200">
// //             <p className="flex items-center gap-2 text-sm">
// //               <span className="font-semibold">Email:</span> info@kevmark.com
// //             </p>
// //             <p className="flex items-center gap-2 text-sm">
// //               <span className="font-semibold">Phone:</span> +256 700 123 456
// //             </p>
// //             <p className="flex items-center gap-2 text-sm">
// //               <span className="font-semibold">Address:</span> Kampala, Uganda
// //             </p>
// //           </div>
// //         </div>

// //         {/* Right Side: Form */}
// //         <div className="bg-white p-8 sm:p-10 rounded-2xl shadow-md">
// //           <h3 className="text-xl font-bold text-gray-900 mb-4">
// //             Send a Message
// //           </h3>
// //           <form className="space-y-4">
// //             <div className="grid sm:grid-cols-2 gap-4">
// //               <div className="relative">
// //                 <input
// //                   type="text"
// //                   id="name"
// //                   placeholder="Your Name"
// //                   className="peer w-full border-b-2 border-gray-300 focus:border-blue-600 outline-none py-2 placeholder-transparent transition-all"
// //                 />
// //                 <label
// //                   htmlFor="name"
// //                   className="absolute left-0 top-2 text-gray-400 text-xs
// //                     peer-placeholder-shown:top-2 peer-placeholder-shown:text-gray-400 peer-placeholder-shown:text-sm
// //                     peer-focus:top-0 peer-focus:text-blue-600 peer-focus:text-xs transition-all"
// //                 >
// //                   Your Name
// //                 </label>
// //               </div>
// //               <div className="relative">
// //                 <input
// //                   type="email"
// //                   id="email"
// //                   placeholder="Your Email"
// //                   className="peer w-full border-b-2 border-gray-300 focus:border-blue-600 outline-none py-2 placeholder-transparent transition-all"
// //                 />
// //                 <label
// //                   htmlFor="email"
// //                   className="absolute left-0 top-2 text-gray-400 text-xs
// //                     peer-placeholder-shown:top-2 peer-placeholder-shown:text-gray-400 peer-placeholder-shown:text-sm
// //                     peer-focus:top-0 peer-focus:text-blue-600 peer-focus:text-xs transition-all"
// //                 >
// //                   Your Email
// //                 </label>
// //               </div>
// //             </div>
// //             <div className="relative">
// //               <textarea
// //                 id="message"
// //                 rows="4"
// //                 placeholder="Your Message"
// //                 className="peer w-full border-b-2 border-gray-300 focus:border-blue-600 outline-none py-2 placeholder-transparent transition-all"
// //               ></textarea>
// //               <label
// //                 htmlFor="message"
// //                 className="absolute left-0 top-2 text-gray-400 text-xs
// //                   peer-placeholder-shown:top-2 peer-placeholder-shown:text-gray-400 peer-placeholder-shown:text-sm
// //                   peer-focus:top-0 peer-focus:text-blue-600 peer-focus:text-xs transition-all"
// //               >
// //                 Your Message
// //               </label>
// //             </div>
// //             <button
// //               type="submit"
// //               className="w-full bg-blue-600 text-white py-2 rounded-lg font-medium hover:bg-blue-700 transition-all shadow-md"
// //             >
// //               Send Message
// //             </button>
// //             <p className="text-gray-400 text-xs mt-2 text-center">
// //               We usually respond within{" "}
// //               <span className="font-medium text-gray-700">24 hours</span>
// //             </p>
// //           </form>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // }

// import React, { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// export function Contact() {
//   const { pathname } = useLocation();

//   // Scroll to top on route change
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);

//   // return (
//   //   <section
//   //     id="contact"
//   //     className="relative bg-gray-50 py-16 px-6 sm:px-12 overflow-hidden"
//   //   >
//   //     {/* Background Circles */}
//   //     <div className="absolute -top-24 -right-24 w-[300px] h-[300px] bg-gradient-to-tr from-blue-400 to-purple-400 rounded-full opacity-15 blur-3xl animate-pulse-slow"></div>
//   //     <div className="absolute -bottom-24 -left-24 w-[250px] h-[250px] bg-gradient-to-tr from-pink-300 to-yellow-300 rounded-full opacity-10 blur-2xl"></div>

//   //     <div className="max-w-4xl mx-auto grid lg:grid-cols-2 gap-10 items-center relative z-10">
//   //       {/* Left Side: Info */}
//   //       <div className="space-y-5 flex flex-col justify-center">
//   //         <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900">
//   //           Get in Touch with{" "}
//   //           <span className="text-blue-600">KevMark Investments</span>
//   //         </h2>
//   //         <p className="text-gray-700 text-base sm:text-lg">
//   //           Have questions about investments, partnerships, or our services?
//   //           We’re here to help you achieve your financial goals. Fill out the
//   //           form and we’ll get back to you promptly.
//   //         </p>

//   //         <div className="space-y-3 text-gray-700 text-sm sm:text-base">
//   //           <p className="flex items-center gap-2">
//   //             <span className="font-semibold">Email:</span> info@kevmark.com
//   //           </p>
//   //           <p className="flex items-center gap-2">
//   //             <span className="font-semibold">Phone:</span> +256 700 123 456
//   //           </p>
//   //           <p className="flex items-center gap-2">
//   //             <span className="font-semibold">Address:</span> Kampala, Uganda
//   //           </p>
//   //         </div>
//   //       </div>

//   //       {/* Right Side: Form */}
//   //       <div className="bg-white p-8 sm:p-10 rounded-xl shadow-md">
//   //         <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
//   //           Send a Message
//   //         </h3>
//   //         <form className="space-y-5">
//   //           <div className="grid sm:grid-cols-2 gap-4">
//   //             <div className="relative">
//   //               <input
//   //                 type="text"
//   //                 id="name"
//   //                 placeholder="Your Name"
//   //                 className="w-full px-4 py-2 text-base sm:text-lg border border-gray-300 rounded-md focus:border-blue-600 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all"
//   //               />
//   //               <label
//   //                 htmlFor="name"
//   //                 className="absolute -top-3 left-2 px-1 bg-white text-sm sm:text-base text-gray-500 peer-focus:text-blue-600 transition-all"
//   //               >
//   //                 Your Name
//   //               </label>
//   //             </div>
//   //             <div className="relative">
//   //               <input
//   //                 type="email"
//   //                 id="email"
//   //                 placeholder="Your Email"
//   //                 className="w-full px-4 py-2 text-base sm:text-lg border border-gray-300 rounded-md focus:border-blue-600 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all"
//   //               />
//   //               <label
//   //                 htmlFor="email"
//   //                 className="absolute -top-3 left-2 px-1 bg-white text-sm sm:text-base text-gray-500 peer-focus:text-blue-600 transition-all"
//   //               >
//   //                 Your Email
//   //               </label>
//   //             </div>
//   //           </div>
//   //           <div className="relative">
//   //             <textarea
//   //               id="message"
//   //               rows="4"
//   //               placeholder="Your Message"
//   //               className="w-full px-4 py-2 text-base sm:text-lg border border-gray-300 rounded-md focus:border-blue-600 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all"
//   //             ></textarea>
//   //             <label
//   //               htmlFor="message"
//   //               className="absolute -top-3 left-2 px-1 bg-white text-sm sm:text-base text-gray-500 peer-focus:text-blue-600 transition-all"
//   //             >
//   //               Your Message
//   //             </label>
//   //           </div>
//   //           <button
//   //             type="submit"
//   //             className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition-all shadow-sm text-base sm:text-lg"
//   //           >
//   //             Send Message
//   //           </button>
//   //           <p className="text-gray-500 text-sm sm:text-base text-center">
//   //             We usually respond within{" "}
//   //             <span className="font-medium text-gray-700">24 hours</span>
//   //           </p>
//   //         </form>
//   //       </div>
//   //     </div>
//   //   </section>
//   // );

//   return (
//     <section
//       id="contact"
//       className="relative bg-gray-50 py-20 px-6 sm:px-12 overflow-hidden"
//     >
//       {/* Background Circles */}
//       <div className="absolute -top-32 -right-32 w-80 h-80 bg-gradient-to-tr from-blue-400 to-purple-500 rounded-full opacity-20 blur-3xl"></div>
//       <div className="absolute -bottom-32 -left-32 w-64 h-64 bg-gradient-to-tr from-pink-300 to-yellow-300 rounded-full opacity-15 blur-2xl"></div>

//       <div className="max-w-5xl mx-auto grid lg:grid-cols-2 gap-12 items-center relative z-10">
//         {/* Left Side: Info */}
//         <div className="space-y-6 flex flex-col justify-center">
//           <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900">
//             Connect with{" "}
//             <span className="text-blue-600">KevMark Investments</span>
//           </h2>
//           <p className="text-gray-700 text-base sm:text-lg">
//             Have questions about investments, partnerships, or our services?
//             Fill out the form and our team will get back to you promptly.
//           </p>

//           <div className="space-y-3 text-gray-700 text-sm sm:text-base">
//             <p>
//               <span className="font-semibold">Email:</span> info@kevmark.com
//             </p>
//             <p>
//               <span className="font-semibold">Phone:</span> +256 700 123 456
//             </p>
//             <p>
//               <span className="font-semibold">Address:</span> Kampala, Uganda
//             </p>
//           </div>
//         </div>

//         {/* Right Side: Form */}
//         <div className="bg-white p-8 sm:p-10 rounded-xl shadow-md border border-gray-100">
//           <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-6">
//             Send a Message
//           </h3>
//           <form className="space-y-5">
//             <div className="grid sm:grid-cols-2 gap-4">
//               <input
//                 type="text"
//                 placeholder="Your Name"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-blue-600 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all text-gray-700"
//               />
//               <input
//                 type="email"
//                 placeholder="Your Email"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-blue-600 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all text-gray-700"
//               />
//             </div>
//             <textarea
//               rows="5"
//               placeholder="Your Message"
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-blue-600 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all text-gray-700"
//             ></textarea>
//             <button
//               type="submit"
//               className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition-all text-base sm:text-lg"
//             >
//               Send Message
//             </button>
//             <p className="text-gray-500 text-sm sm:text-base text-center">
//               We usually respond within{" "}
//               <span className="font-medium text-gray-700">24 hours</span>
//             </p>
//           </form>
//         </div>
//       </div>
//     </section>
//   );
// }

// Contact.tsx
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPaperPlane,
} from "react-icons/fa";

export function Contact() {
  const { pathname } = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <section
      id="contact"
      className="py-20 px-6 bg-gradient-to-b from-white to-gray-50"
      style={{ minHeight: "calc(100vh - 80px)" }}
    >
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            Get in Touch
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
            Whether you need ICT solutions, stationery, branding, or printing —
            our team is ready to help.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left: Contact Info */}
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-semibold text-gray-800 mb-6">
                Contact Information
              </h3>
              <div className="space-y-5 text-gray-700">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                    <FaMapMarkerAlt className="w-5 h-5 text-blue-700" />
                  </div>
                  <div>
                    <p className="font-medium">Physical Address</p>
                    <p className="text-sm mt-1">
                      OFFICE NO: NK003, NKURUMAH NASER LINK PLAZA,
                      <br />
                      Plot 59, Nkrumah Road, Kampala, Uganda
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                    <FaPhone className="w-5 h-5 text-green-700" />
                  </div>
                  <div>
                    <p className="font-medium">Call Us</p>
                    <p className="text-sm mt-1">
                      +256 772 551 508
                      <br />
                      +256 752 551 508
                      <br />
                      +256 414 232 531
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                    <FaEnvelope className="w-5 h-5 text-purple-700" />
                  </div>
                  <div>
                    <p className="font-medium">Email Us</p>
                    <p className="text-sm mt-1">
                      <a
                        href="mailto:Kevmark2000@gmail.com"
                        className="hover:text-blue-600 transition"
                      >
                        md@kevmarkinvestments.com
                      </a>
                      <br />
                      <a
                        href="mailto:Kevmarksales@gmail.com"
                        className="hover:text-blue-600 transition"
                      >
                        sales@kevmarkinvestments.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Trust Badge */}
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 text-center">
              <p className="text-sm text-blue-800 font-medium">
                Established in 2008 • Serving Uganda with Excellence
              </p>
            </div>
          </div>

          {/* Right: Contact Form */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Send Us a Message
            </h3>
            <form className="space-y-6">
              <div className="grid sm:grid-cols-2 gap-6">
                <input
                  type="text"
                  placeholder="Your Name"
                  className="w-full px-5 py-3 border border-gray-300 rounded-lg focus:border-blue-600 focus:ring-4 focus:ring-blue-100 outline-none transition text-gray-700"
                  required
                />
                <input
                  type="email"
                  placeholder="Your Email"
                  className="w-full px-5 py-3 border border-gray-300 rounded-lg focus:border-blue-600 focus:ring-4 focus:ring-blue-100 outline-none transition text-gray-700"
                  required
                />
              </div>

              <input
                type="text"
                placeholder="Subject (e.g. Website Design, Printing Quote)"
                className="w-full px-5 py-3 border border-gray-300 rounded-lg focus:border-blue-600 focus:ring-4 focus:ring-blue-100 outline-none transition text-gray-700"
              />

              <textarea
                rows={5}
                placeholder="Your Message"
                className="w-full px-5 py-3 border border-gray-300 rounded-lg focus:border-blue-600 focus:ring-4 focus:ring-blue-100 outline-none transition text-gray-700 resize-none"
                required
              ></textarea>

              <button
                type="submit"
                className="w-full bg-blue-700 text-white py-3.5 rounded-lg font-semibold hover:bg-blue-800 flex items-center justify-center gap-2 transition shadow-md"
              >
                <FaPaperPlane className="w-5 h-5" />
                Send Message
              </button>

              <p className="text-center text-sm text-gray-500">
                We typically respond within{" "}
                <span className="font-medium text-gray-700">24 hours</span>
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
